module.exports = __webpack_public_path__ + "static/media/plus.f7c686a0.svg";